import { withStyles } from '@material-ui/core/styles';
import { Table } from '../Table';

export const StyledTable = withStyles(() => ({
	root: {
		borderCollapse: 'separate',
		borderSpacing: '0 8px'
	}
}))(Table);
